import GenericDialog from "./GenericDialog";

const SubscriptionNeededPopup = ({
                                     onClose,
                                     title = "Subscription Needed",
                                     text = "You’ve discovered a premium feature. To unlock access to this feature, you’ll need to upgrade to a silver or gold plan."
                                 }) => {

    const handleResult = (action) => {
        if (action === "back") {
            onClose();
        }

        if (action === "upgrade") {
            window.location.href = "/pricing-plans";
        }

        if (action === "learn") {
            window.location.href = "/faq?scrollTo=subscription";
        }
    };

    const buttons = [
        { id: "back", text: "Go Back" },
        { id: "learn", text: "Learn More" },
        { id: "upgrade", text: "Upgrade" }
    ];

    return (
        <GenericDialog
            title={title}
            text={text}
            buttons={buttons}
            result={handleResult}
            onClose={onClose}
            wide={false}
        />
    );
};

export default SubscriptionNeededPopup;